import { render } from "./Modal.vue?vue&type=template&id=492c2b1d&scoped=true&lang=pug"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=492c2b1d&lang=sass&scoped=true"

import exportComponent from "D:\\Front\\project\\valeriya.artist\\valeriya.artist.admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-492c2b1d"]])

export default __exports__